var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.currentUser.acl.includes('*'))?_c('div',[_c('h1',[_vm._v("Sistema de Gestión")])]):_c('div',[(_vm.success)?_c('div',{staticClass:"container"},[_c('list-panel',{attrs:{"moves":_vm.moves}}),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }